export const LOAD_TICKET_TYPES = "LOAD_TICKET_TYPES"